(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-add-sheet"] && !Shopify.designMode) return;
  try {
    /**
   * Igual que el cajón: <dialog> nativo por la trampa de foco, Escape, fondo
   * inerte y backdrop. Lo propio aquí es traer el contenido y mantener el
   * precio y la cantidad sincronizados con el botón de agregar.
   */
  class QuickAddSheet extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.cuerpo = this.querySelector('[data-quick-add-cuerpo]');
      this.vacio = this.cuerpo.innerHTML;
      this.cantidad = 1;

      document.addEventListener('click', (event) => {
        const disparador = event.target.closest('[data-quick-add]');
        if (!disparador) return;
        event.preventDefault();
        this.abrir(disparador.getAttribute('data-quick-add'));
      });

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-quick-add-close]')) return this.cerrar();
        if (event.target === this.dialog) return this.cerrar();
        if (event.target.closest('[data-qa-menos]')) return this.cambiarCantidad(-1);
        if (event.target.closest('[data-qa-mas]')) return this.cambiarCantidad(1);
      });

      this.addEventListener('change', (event) => {
        if (event.target.name === 'qa-variante') this.elegirVariante(event.target);
      });

      // El alta la hace cart.js; la hoja sólo se quita de en medio para que se
      // vea el cajón, que es la confirmación real de que algo entró.
      document.addEventListener('nanah:cart:updated', () => {
        if (this.dialog.open) this.cerrar();
      });

      this.dialog.addEventListener('close', () => this.dialog.classList.remove('is-open'));
    }

    async abrir(url) {
      this.cantidad = 1;
      this.cuerpo.innerHTML = this.vacio;
      this.dialog.showModal();
      requestAnimationFrame(() => this.dialog.classList.add('is-open'));

      const separador = url.indexOf('?') === -1 ? '?' : '&';
      try {
        const respuesta = await fetch(url + separador + 'view=quick-add');
        if (!respuesta.ok) throw new Error('HTTP ' + respuesta.status);
        this.cuerpo.innerHTML = await respuesta.text();
      } catch (error) {
        // No se traga: se registra y la hoja se aparta para que el enlace de
        // la tarjeta siga siendo un camino válido al producto.
        console.error('[nanah:quick-add] no se pudo cargar ' + url + ':', error);
        this.cerrar();
        window.location.href = url;
      }
    }

    cerrar() {
      if (!this.dialog.open) return;
      this.dialog.classList.remove('is-open');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.dialog.close();
        return;
      }
      let cerrado = false;
      const cerrar = () => {
        if (cerrado) return;
        cerrado = true;
        this.dialog.close();
      };
      this.dialog.addEventListener('transitionend', cerrar, { once: true });
      setTimeout(cerrar, 400);
    }

    cambiarCantidad(delta) {
      const salida = this.querySelector('[data-qa-cant]');
      const atc = this.querySelector('.qa__atc');
      if (!salida || !atc) return;
      this.cantidad = Math.max(1, this.cantidad + delta);
      salida.textContent = this.cantidad;
      atc.setAttribute('data-cart-quantity', String(this.cantidad));
    }

    /** El precio ya viene formateado por Liquid en el data del chip: aquí no
     *  se formatea dinero, igual que en el resto del tema. */
    elegirVariante(radio) {
      const atc = this.querySelector('.qa__atc');
      const precio = this.querySelector('[data-qa-precio]');
      if (atc) atc.setAttribute('data-cart-add', radio.value);
      if (!precio) return;

      const comparado = radio.getAttribute('data-comparado');
      precio.textContent = radio.getAttribute('data-precio');
      if (comparado) {
        const s = document.createElement('s');
        s.className = 'qa__lst';
        s.textContent = comparado;
        precio.appendChild(s);
      }
    }
  }

  if (!customElements.get('quick-add-sheet')) customElements.define('quick-add-sheet', QuickAddSheet);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-clip"] && !Shopify.designMode) return;
  try {
    /**
   * Un solo manejador delegado para todos los clips de la página. El <video>
   * se crea al tocar; antes de eso no existe, así que el navegador no abre
   * ninguna conexión de video al cargar.
   */
  document.addEventListener('click', (event) => {
    const boton = event.target.closest('.clip__play');
    if (!boton || boton.classList.contains('is-playing')) return;

    const fuentes = (boton.getAttribute('data-video-src') || '')
      .split(',')
      .map((entrada) => entrada.split('|'))
      .filter((par) => par[0]);
    if (!fuentes.length) {
      console.error('[nanah:video] el clip no trae fuentes');
      return;
    }

    const video = document.createElement('video');
    video.setAttribute('playsinline', '');
    video.setAttribute('controls', '');
    video.setAttribute('preload', 'none');
    /* RONDA 5 — «los videos no llevan audio, sólo deben poder reproducirse».
     * `muted` en la propiedad y en el atributo: la propiedad es la que manda
     * en el elemento y el atributo es el que mira el navegador para decidir si
     * permite el autoplay. Con los dos puestos, el clip arranca solo y sin
     * sonido en todos los casos. */
    video.muted = true;
    video.setAttribute('muted', '');
    video.autoplay = true;
    for (const [url, mime] of fuentes) {
      const source = document.createElement('source');
      source.src = url;
      if (mime) source.type = mime;
      video.appendChild(source);
    }

    const poster = boton.querySelector('img');
    if (poster) poster.replaceWith(video);
    else boton.prepend(video);
    boton.classList.add('is-playing');

    // play() rechaza si el navegador bloquea el autoplay; con controls puestos
    // la persona puede darle igual, así que sólo se registra.
    const intento = video.play();
    if (intento && intento.catch) {
      intento.catch((error) => console.error('[nanah:video] no se pudo reproducir:', error));
    }
  });
  } catch(e) { console.error(e); }
})();

})();
